"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Badge = _interopRequireDefault(require("@mui/material/Badge"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var styles = exports.styles = function styles(theme) {
  return {
    // Usefull for style overriding
    root: {},
    primary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },
    secondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },
    success: {
      backgroundColor: theme.palette.success.main,
      color: theme.palette.success.contrastText
    },
    error: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText
    },
    warning: {
      backgroundColor: theme.palette.warning.main,
      color: theme.palette.warning.contrastText
    },
    neutral: {
      backgroundColor: theme.palette.neutral.main,
      color: theme.palette.neutral.contrastText
    },
    badge: {
      borderRadius: 4,
      fontWeight: 500,
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.primary.contrastText,
      height: 18,
      top: -4,
      right: 6,
      paddingTop: 2
    },
    shortBadge: {
      width: 18
    },
    mediumBadge: {
      minWidth: 24
    },
    longBadge: {
      minWidth: 40
    }
  };
};
function HiBadge(props) {
  var classes = props.classes,
    className = props.className,
    children = props.children,
    color = props.color,
    value = props.value;
  var length = value.toString().length;
  var finalValue = value > 100 ? '+100' : value;
  var badgeClass = (0, _classnames.default)(classes.badge, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.primary, color === 'primary'), classes.secondary, color === 'secondary'), classes.success, color === 'success'), classes.error, color === 'error'), classes.warning, color === 'warning'), classes.neutral, color === 'neutral'), classes.shortBadge, length < 2), classes.mediumBadge, length === 2), classes.longBadge, length > 2));
  return /*#__PURE__*/_react.default.createElement(_Badge.default, {
    className: className,
    classes: {
      root: classes.root,
      badge: badgeClass,
      colorPrimary: classes.primary
    },
    badgeContent: finalValue
  }, children);
}
HiBadge.defaultProps = {
  color: 'primary'
};
var _default = exports.default = (0, _withStyles.default)(styles, {
  hiComponent: true,
  name: 'HmuiHiBadge'
})(HiBadge);